module.exports = __webpack_public_path__ + "media/typewriter.bc528691.mp3";